import React, { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import SearchHeader from "../components/SearchHeader";
import Notice from "../components/notices/Notice";
import { useLoader } from "../context/LoaderContext";
import { fetchNotices } from "../api/NoticeApi";
import { INotice } from "../exports/interfaces";
import { dynamicFailed } from "../hooks/useToast";
import { useUser } from "../context/UserContext";

const NoticesPage = () => {
  const { setLoading } = useLoader();
  const [notice, setNotice] = useState<INotice[]>([]);
  const { user } = useUser();
  useEffect(() => {
    if (!user) {
      return;
    }
    Promise.all([fetchNotices()])
      .then(([noticeData]) => {
        setNotice(noticeData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        dynamicFailed(`${error.message}`);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading, user]);
  return (
    <PageLayout>
      <SearchHeader />
      <div className="inner-main-content">
        <Notice notice={notice} setNotice={setNotice} />
      </div>
    </PageLayout>
  );
};

export default NoticesPage;
